var _desc, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidbarcodenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0.0000mm",
    y: "0.0000mm",
    width: "109.2730mm",
    height: "109.2730mm",
    viewBox: "0.0000 0.0000 109.2730 109.2730",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TBarCode - 11.17.1.16949") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "BarCode licensed to MEM:TEC-IT Datenverarbeitung GmbH Internal License")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%,100%,100%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 109.273,
    height: 109.273
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 0,
    width: 3.3113,
    height: 3.3113
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 3.3113,
    width: 3.3113,
    height: 3.3113
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 6.6226,
    width: 3.3113,
    height: 3.3113
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 9.9339,
    width: 3.3113,
    height: 3.3113
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 13.2452,
    width: 3.3113,
    height: 3.3113
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 16.5565,
    width: 3.3113,
    height: 3.3113
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 19.8678,
    width: 3.3113,
    height: 3.3113
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 23.1791,
    width: 3.3113,
    height: 3.3113
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 26.4904,
    width: 3.3113,
    height: 3.3113
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 29.8017,
    width: 3.3113,
    height: 3.3113
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 33.113,
    width: 3.3113,
    height: 3.3113
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 36.4243,
    width: 3.3113,
    height: 3.3113
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 39.7356,
    width: 3.3113,
    height: 3.3113
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 43.0469,
    width: 3.3113,
    height: 3.3113
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 46.3582,
    width: 3.3113,
    height: 3.3113
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 49.6695,
    width: 3.3113,
    height: 3.3113
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 52.9808,
    width: 3.3113,
    height: 3.3113
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 56.2922,
    width: 3.3113,
    height: 3.3113
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 59.6035,
    width: 3.3113,
    height: 3.3113
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 62.9148,
    width: 3.3113,
    height: 3.3113
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 66.2261,
    width: 3.3113,
    height: 3.3113
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 69.5374,
    width: 3.3113,
    height: 3.3113
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 72.8487,
    width: 3.3113,
    height: 3.3113
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 76.16,
    width: 3.3113,
    height: 3.3113
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1791,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 79.4713,
    width: 3.3113,
    height: 3.3113
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 82.7826,
    width: 3.3113,
    height: 3.3113
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 86.0939,
    width: 3.3113,
    height: 3.3113
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9617,
    y: 89.4052,
    width: 3.3113,
    height: 3.3113
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 92.7165,
    width: 3.3113,
    height: 3.3113
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.9148,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7165,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 96.0278,
    width: 3.3113,
    height: 3.3113
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9808,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 99.3391,
    width: 3.3113,
    height: 3.3113
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.113,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6035,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2261,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5374,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7826,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0278,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.3391,
    y: 102.6504,
    width: 3.3113,
    height: 3.3113
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3113,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6226,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9339,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2452,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5565,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8678,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4904,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8017,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4243,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7356,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0469,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3582,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6695,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2922,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8487,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4713,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0939,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4052,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6504,
    y: 105.9617,
    width: 3.3113,
    height: 3.3113
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidbarcodenew);
export default __webpack_public_path__ + "static/media/androidbarcodenew.956176e86199556099686d9cbbb8b978.svg";
export { ForwardRef as ReactComponent };